export type ReasonForValuation =
    | 'transaction'
    | 'recurring_valuation'
    | 'division_of_wealth'
    | 'statement_of_assets'
    | 'financing_purposes'
    | 'court_proceedings'
    | 'purchase'
    | 'sale'
    | 'tax_purposes'
    | 'partial_sale'
    | 'accounting_purposes'
    | 'intrinsic_value_check'
    | 'auction'
    | 'lending_purposes'

export type ValuationReasonOption = { value: ReasonForValuation; label: string }

type ValuationReasonOptionGroup = { label: string; options: ValuationReasonOption[] }

export type ValuationReasonGroupedOptions = Record<string, ValuationReasonOptionGroup>

export const CREATE_ORDER_VALUATION_REASON_GROUPED_OPTIONS: ValuationReasonGroupedOptions = {
    recurringValuation: {
        label: 'Regelmäßiges Wertgutachten',
        options: [{ value: 'recurring_valuation', label: 'Regelmäßiges Wertgutachten' }],
    },
    legalReasons: {
        label: 'Rechtlicher Hintergrund',
        options: [
            { value: 'division_of_wealth', label: 'Aufteilung des Vermögens' },
            { value: 'court_proceedings', label: 'Gerichtsverfahren' },
        ],
    },
    accountingSomething: {
        label: 'Buchführung',
        options: [
            { value: 'accounting_purposes', label: 'Bilanzierung' },
            { value: 'tax_purposes', label: 'Steuerliche Zwecke' },
            { value: 'intrinsic_value_check', label: 'Überprüfung der Werthaltigkeit' },
        ],
    },
    transactions: {
        label: 'Handel',
        options: [
            { value: 'purchase', label: 'Ankauf' },
            { value: 'sale', label: 'Verkauf' },
            { value: 'partial_sale', label: 'Teilverkauf' },
            { value: 'auction', label: 'Versteigerung' },
            { value: 'financing_purposes', label: 'Finanzierungszwecke' },
        ],
    },
}

const valuationReasonOptions: ValuationReasonOption[] = Object.values(CREATE_ORDER_VALUATION_REASON_GROUPED_OPTIONS).flatMap(
    ({ options }) => options
)

const legacyValuationReasonLabels: Partial<Record<ReasonForValuation, string>> = {
    transaction: 'Transaktion',
    statement_of_assets: 'Vermögensaufstellung',
    lending_purposes: 'Beleihung',
}

const valuationReasonLabels: Partial<Record<ReasonForValuation, string>> = valuationReasonOptions.reduce((result, option) => {
    result[option.value] = option.label
    return result
}, legacyValuationReasonLabels)

export const getValuationReasonText = (reason: ReasonForValuation) => valuationReasonLabels[reason] ?? reason
